/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiCommonStackholdersCreateStackholderPost } from '../fn/stackholders/api-common-stackholders-create-stackholder-post';
import { ApiCommonStackholdersCreateStackholderPost$Params } from '../fn/stackholders/api-common-stackholders-create-stackholder-post';
import { apiCommonStackholdersCreateStackholderPost$Plain } from '../fn/stackholders/api-common-stackholders-create-stackholder-post-plain';
import { ApiCommonStackholdersCreateStackholderPost$Plain$Params } from '../fn/stackholders/api-common-stackholders-create-stackholder-post-plain';
import { apiCommonStackholdersDeleteStackholderDelete } from '../fn/stackholders/api-common-stackholders-delete-stackholder-delete';
import { ApiCommonStackholdersDeleteStackholderDelete$Params } from '../fn/stackholders/api-common-stackholders-delete-stackholder-delete';
import { apiCommonStackholdersDeleteStackholderDelete$Plain } from '../fn/stackholders/api-common-stackholders-delete-stackholder-delete-plain';
import { ApiCommonStackholdersDeleteStackholderDelete$Plain$Params } from '../fn/stackholders/api-common-stackholders-delete-stackholder-delete-plain';
import { apiCommonStackholdersGetChildsByParentIdPost } from '../fn/stackholders/api-common-stackholders-get-childs-by-parent-id-post';
import { ApiCommonStackholdersGetChildsByParentIdPost$Params } from '../fn/stackholders/api-common-stackholders-get-childs-by-parent-id-post';
import { apiCommonStackholdersGetChildsByParentIdPost$Plain } from '../fn/stackholders/api-common-stackholders-get-childs-by-parent-id-post-plain';
import { ApiCommonStackholdersGetChildsByParentIdPost$Plain$Params } from '../fn/stackholders/api-common-stackholders-get-childs-by-parent-id-post-plain';
import { apiCommonStackholdersGetStackholderByIdPost } from '../fn/stackholders/api-common-stackholders-get-stackholder-by-id-post';
import { ApiCommonStackholdersGetStackholderByIdPost$Params } from '../fn/stackholders/api-common-stackholders-get-stackholder-by-id-post';
import { apiCommonStackholdersGetStackholderByIdPost$Plain } from '../fn/stackholders/api-common-stackholders-get-stackholder-by-id-post-plain';
import { ApiCommonStackholdersGetStackholderByIdPost$Plain$Params } from '../fn/stackholders/api-common-stackholders-get-stackholder-by-id-post-plain';
import { apiCommonStackholdersGetStackholdersByUserIdPost } from '../fn/stackholders/api-common-stackholders-get-stackholders-by-user-id-post';
import { ApiCommonStackholdersGetStackholdersByUserIdPost$Params } from '../fn/stackholders/api-common-stackholders-get-stackholders-by-user-id-post';
import { apiCommonStackholdersGetStackholdersByUserIdPost$Plain } from '../fn/stackholders/api-common-stackholders-get-stackholders-by-user-id-post-plain';
import { ApiCommonStackholdersGetStackholdersByUserIdPost$Plain$Params } from '../fn/stackholders/api-common-stackholders-get-stackholders-by-user-id-post-plain';
import { apiCommonStackholdersGetStackholdersPost } from '../fn/stackholders/api-common-stackholders-get-stackholders-post';
import { ApiCommonStackholdersGetStackholdersPost$Params } from '../fn/stackholders/api-common-stackholders-get-stackholders-post';
import { apiCommonStackholdersGetStackholdersPost$Plain } from '../fn/stackholders/api-common-stackholders-get-stackholders-post-plain';
import { ApiCommonStackholdersGetStackholdersPost$Plain$Params } from '../fn/stackholders/api-common-stackholders-get-stackholders-post-plain';
import { apiCommonStackholdersGetStakeholderChildsPost } from '../fn/stackholders/api-common-stackholders-get-stakeholder-childs-post';
import { ApiCommonStackholdersGetStakeholderChildsPost$Params } from '../fn/stackholders/api-common-stackholders-get-stakeholder-childs-post';
import { apiCommonStackholdersGetStakeholderChildsPost$Plain } from '../fn/stackholders/api-common-stackholders-get-stakeholder-childs-post-plain';
import { ApiCommonStackholdersGetStakeholderChildsPost$Plain$Params } from '../fn/stackholders/api-common-stackholders-get-stakeholder-childs-post-plain';
import { apiCommonStackholdersGetStakeholderTreePost } from '../fn/stackholders/api-common-stackholders-get-stakeholder-tree-post';
import { ApiCommonStackholdersGetStakeholderTreePost$Params } from '../fn/stackholders/api-common-stackholders-get-stakeholder-tree-post';
import { apiCommonStackholdersGetStakeholderTreePost$Plain } from '../fn/stackholders/api-common-stackholders-get-stakeholder-tree-post-plain';
import { ApiCommonStackholdersGetStakeholderTreePost$Plain$Params } from '../fn/stackholders/api-common-stackholders-get-stakeholder-tree-post-plain';
import { apiCommonStackholdersGetUsersByStackHolderPost } from '../fn/stackholders/api-common-stackholders-get-users-by-stack-holder-post';
import { ApiCommonStackholdersGetUsersByStackHolderPost$Params } from '../fn/stackholders/api-common-stackholders-get-users-by-stack-holder-post';
import { apiCommonStackholdersGetUsersByStackHolderPost$Plain } from '../fn/stackholders/api-common-stackholders-get-users-by-stack-holder-post-plain';
import { ApiCommonStackholdersGetUsersByStackHolderPost$Plain$Params } from '../fn/stackholders/api-common-stackholders-get-users-by-stack-holder-post-plain';
import { apiCommonStackholdersUpdateStackholderPatch } from '../fn/stackholders/api-common-stackholders-update-stackholder-patch';
import { ApiCommonStackholdersUpdateStackholderPatch$Params } from '../fn/stackholders/api-common-stackholders-update-stackholder-patch';
import { apiCommonStackholdersUpdateStackholderPatch$Plain } from '../fn/stackholders/api-common-stackholders-update-stackholder-patch-plain';
import { ApiCommonStackholdersUpdateStackholderPatch$Plain$Params } from '../fn/stackholders/api-common-stackholders-update-stackholder-patch-plain';
import { CreateStackholderCommandResult } from '../models/create-stackholder-command-result';
import { DeleteStackholderCommandResult } from '../models/delete-stackholder-command-result';
import { GetChildsByParentIdQueryResult } from '../models/get-childs-by-parent-id-query-result';
import { GetStackholderQueryResult } from '../models/get-stackholder-query-result';
import { GetStackholdersByUserIdQueryResult } from '../models/get-stackholders-by-user-id-query-result';
import { GetStackholdersQueryResult } from '../models/get-stackholders-query-result';
import { GetStakeholderChildsQueryResult } from '../models/get-stakeholder-childs-query-result';
import { GetStakeholderTreeQueryResult } from '../models/get-stakeholder-tree-query-result';
import { GetUsersByStackHolderQueryResult } from '../models/get-users-by-stack-holder-query-result';
import { UpdateStackholderCommandResult } from '../models/update-stackholder-command-result';

@Injectable({ providedIn: 'root' })
export class StackholdersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCommonStackholdersGetUsersByStackHolderPost()` */
  static readonly ApiCommonStackholdersGetUsersByStackHolderPostPath = '/api/Common/Stackholders/GetUsersByStackHolder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetUsersByStackHolderPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersGetUsersByStackHolderPost$Plain$Response(params?: ApiCommonStackholdersGetUsersByStackHolderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUsersByStackHolderQueryResult>> {
    return apiCommonStackholdersGetUsersByStackHolderPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetUsersByStackHolderPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersGetUsersByStackHolderPost$Plain(params?: ApiCommonStackholdersGetUsersByStackHolderPost$Plain$Params, context?: HttpContext): Observable<GetUsersByStackHolderQueryResult> {
    return this.apiCommonStackholdersGetUsersByStackHolderPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUsersByStackHolderQueryResult>): GetUsersByStackHolderQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetUsersByStackHolderPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersGetUsersByStackHolderPost$Response(params?: ApiCommonStackholdersGetUsersByStackHolderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUsersByStackHolderQueryResult>> {
    return apiCommonStackholdersGetUsersByStackHolderPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetUsersByStackHolderPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersGetUsersByStackHolderPost(params?: ApiCommonStackholdersGetUsersByStackHolderPost$Params, context?: HttpContext): Observable<GetUsersByStackHolderQueryResult> {
    return this.apiCommonStackholdersGetUsersByStackHolderPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUsersByStackHolderQueryResult>): GetUsersByStackHolderQueryResult => r.body)
    );
  }

  /** Path part for operation `apiCommonStackholdersGetStackholdersByUserIdPost()` */
  static readonly ApiCommonStackholdersGetStackholdersByUserIdPostPath = '/api/Common/Stackholders/GetStackholdersByUserId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetStackholdersByUserIdPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersGetStackholdersByUserIdPost$Plain$Response(params?: ApiCommonStackholdersGetStackholdersByUserIdPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStackholdersByUserIdQueryResult>> {
    return apiCommonStackholdersGetStackholdersByUserIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetStackholdersByUserIdPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersGetStackholdersByUserIdPost$Plain(params?: ApiCommonStackholdersGetStackholdersByUserIdPost$Plain$Params, context?: HttpContext): Observable<GetStackholdersByUserIdQueryResult> {
    return this.apiCommonStackholdersGetStackholdersByUserIdPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStackholdersByUserIdQueryResult>): GetStackholdersByUserIdQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetStackholdersByUserIdPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersGetStackholdersByUserIdPost$Response(params?: ApiCommonStackholdersGetStackholdersByUserIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStackholdersByUserIdQueryResult>> {
    return apiCommonStackholdersGetStackholdersByUserIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetStackholdersByUserIdPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersGetStackholdersByUserIdPost(params?: ApiCommonStackholdersGetStackholdersByUserIdPost$Params, context?: HttpContext): Observable<GetStackholdersByUserIdQueryResult> {
    return this.apiCommonStackholdersGetStackholdersByUserIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStackholdersByUserIdQueryResult>): GetStackholdersByUserIdQueryResult => r.body)
    );
  }

  /** Path part for operation `apiCommonStackholdersGetStackholdersPost()` */
  static readonly ApiCommonStackholdersGetStackholdersPostPath = '/api/Common/Stackholders/GetStackholders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetStackholdersPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStackholdersPost$Plain$Response(params?: ApiCommonStackholdersGetStackholdersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStackholdersQueryResult>> {
    return apiCommonStackholdersGetStackholdersPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetStackholdersPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStackholdersPost$Plain(params?: ApiCommonStackholdersGetStackholdersPost$Plain$Params, context?: HttpContext): Observable<GetStackholdersQueryResult> {
    return this.apiCommonStackholdersGetStackholdersPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStackholdersQueryResult>): GetStackholdersQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetStackholdersPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStackholdersPost$Response(params?: ApiCommonStackholdersGetStackholdersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStackholdersQueryResult>> {
    return apiCommonStackholdersGetStackholdersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetStackholdersPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStackholdersPost(params?: ApiCommonStackholdersGetStackholdersPost$Params, context?: HttpContext): Observable<GetStackholdersQueryResult> {
    return this.apiCommonStackholdersGetStackholdersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStackholdersQueryResult>): GetStackholdersQueryResult => r.body)
    );
  }

  /** Path part for operation `apiCommonStackholdersGetStakeholderChildsPost()` */
  static readonly ApiCommonStackholdersGetStakeholderChildsPostPath = '/api/Common/Stackholders/GetStakeholderChilds';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetStakeholderChildsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStakeholderChildsPost$Plain$Response(params?: ApiCommonStackholdersGetStakeholderChildsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStakeholderChildsQueryResult>> {
    return apiCommonStackholdersGetStakeholderChildsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetStakeholderChildsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStakeholderChildsPost$Plain(params?: ApiCommonStackholdersGetStakeholderChildsPost$Plain$Params, context?: HttpContext): Observable<GetStakeholderChildsQueryResult> {
    return this.apiCommonStackholdersGetStakeholderChildsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStakeholderChildsQueryResult>): GetStakeholderChildsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetStakeholderChildsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStakeholderChildsPost$Response(params?: ApiCommonStackholdersGetStakeholderChildsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStakeholderChildsQueryResult>> {
    return apiCommonStackholdersGetStakeholderChildsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetStakeholderChildsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStakeholderChildsPost(params?: ApiCommonStackholdersGetStakeholderChildsPost$Params, context?: HttpContext): Observable<GetStakeholderChildsQueryResult> {
    return this.apiCommonStackholdersGetStakeholderChildsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStakeholderChildsQueryResult>): GetStakeholderChildsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiCommonStackholdersGetChildsByParentIdPost()` */
  static readonly ApiCommonStackholdersGetChildsByParentIdPostPath = '/api/Common/Stackholders/GetChildsByParentId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetChildsByParentIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetChildsByParentIdPost$Plain$Response(params?: ApiCommonStackholdersGetChildsByParentIdPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetChildsByParentIdQueryResult>> {
    return apiCommonStackholdersGetChildsByParentIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetChildsByParentIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetChildsByParentIdPost$Plain(params?: ApiCommonStackholdersGetChildsByParentIdPost$Plain$Params, context?: HttpContext): Observable<GetChildsByParentIdQueryResult> {
    return this.apiCommonStackholdersGetChildsByParentIdPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetChildsByParentIdQueryResult>): GetChildsByParentIdQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetChildsByParentIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetChildsByParentIdPost$Response(params?: ApiCommonStackholdersGetChildsByParentIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetChildsByParentIdQueryResult>> {
    return apiCommonStackholdersGetChildsByParentIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetChildsByParentIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetChildsByParentIdPost(params?: ApiCommonStackholdersGetChildsByParentIdPost$Params, context?: HttpContext): Observable<GetChildsByParentIdQueryResult> {
    return this.apiCommonStackholdersGetChildsByParentIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetChildsByParentIdQueryResult>): GetChildsByParentIdQueryResult => r.body)
    );
  }

  /** Path part for operation `apiCommonStackholdersGetStakeholderTreePost()` */
  static readonly ApiCommonStackholdersGetStakeholderTreePostPath = '/api/Common/Stackholders/GetStakeholderTree';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetStakeholderTreePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStakeholderTreePost$Plain$Response(params?: ApiCommonStackholdersGetStakeholderTreePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStakeholderTreeQueryResult>> {
    return apiCommonStackholdersGetStakeholderTreePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetStakeholderTreePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStakeholderTreePost$Plain(params?: ApiCommonStackholdersGetStakeholderTreePost$Plain$Params, context?: HttpContext): Observable<GetStakeholderTreeQueryResult> {
    return this.apiCommonStackholdersGetStakeholderTreePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStakeholderTreeQueryResult>): GetStakeholderTreeQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetStakeholderTreePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStakeholderTreePost$Response(params?: ApiCommonStackholdersGetStakeholderTreePost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStakeholderTreeQueryResult>> {
    return apiCommonStackholdersGetStakeholderTreePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetStakeholderTreePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStakeholderTreePost(params?: ApiCommonStackholdersGetStakeholderTreePost$Params, context?: HttpContext): Observable<GetStakeholderTreeQueryResult> {
    return this.apiCommonStackholdersGetStakeholderTreePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStakeholderTreeQueryResult>): GetStakeholderTreeQueryResult => r.body)
    );
  }

  /** Path part for operation `apiCommonStackholdersGetStackholderByIdPost()` */
  static readonly ApiCommonStackholdersGetStackholderByIdPostPath = '/api/Common/Stackholders/GetStackholderByID';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetStackholderByIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStackholderByIdPost$Plain$Response(params?: ApiCommonStackholdersGetStackholderByIdPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStackholderQueryResult>> {
    return apiCommonStackholdersGetStackholderByIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetStackholderByIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStackholderByIdPost$Plain(params?: ApiCommonStackholdersGetStackholderByIdPost$Plain$Params, context?: HttpContext): Observable<GetStackholderQueryResult> {
    return this.apiCommonStackholdersGetStackholderByIdPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStackholderQueryResult>): GetStackholderQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersGetStackholderByIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStackholderByIdPost$Response(params?: ApiCommonStackholdersGetStackholderByIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStackholderQueryResult>> {
    return apiCommonStackholdersGetStackholderByIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersGetStackholderByIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersGetStackholderByIdPost(params?: ApiCommonStackholdersGetStackholderByIdPost$Params, context?: HttpContext): Observable<GetStackholderQueryResult> {
    return this.apiCommonStackholdersGetStackholderByIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStackholderQueryResult>): GetStackholderQueryResult => r.body)
    );
  }

  /** Path part for operation `apiCommonStackholdersCreateStackholderPost()` */
  static readonly ApiCommonStackholdersCreateStackholderPostPath = '/api/Common/Stackholders/CreateStackholder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersCreateStackholderPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersCreateStackholderPost$Plain$Response(params?: ApiCommonStackholdersCreateStackholderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateStackholderCommandResult>> {
    return apiCommonStackholdersCreateStackholderPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersCreateStackholderPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersCreateStackholderPost$Plain(params?: ApiCommonStackholdersCreateStackholderPost$Plain$Params, context?: HttpContext): Observable<CreateStackholderCommandResult> {
    return this.apiCommonStackholdersCreateStackholderPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateStackholderCommandResult>): CreateStackholderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersCreateStackholderPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersCreateStackholderPost$Response(params?: ApiCommonStackholdersCreateStackholderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateStackholderCommandResult>> {
    return apiCommonStackholdersCreateStackholderPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersCreateStackholderPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersCreateStackholderPost(params?: ApiCommonStackholdersCreateStackholderPost$Params, context?: HttpContext): Observable<CreateStackholderCommandResult> {
    return this.apiCommonStackholdersCreateStackholderPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateStackholderCommandResult>): CreateStackholderCommandResult => r.body)
    );
  }

  /** Path part for operation `apiCommonStackholdersUpdateStackholderPatch()` */
  static readonly ApiCommonStackholdersUpdateStackholderPatchPath = '/api/Common/Stackholders/UpdateStackholder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersUpdateStackholderPatch$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersUpdateStackholderPatch$Plain$Response(params?: ApiCommonStackholdersUpdateStackholderPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateStackholderCommandResult>> {
    return apiCommonStackholdersUpdateStackholderPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersUpdateStackholderPatch$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersUpdateStackholderPatch$Plain(params?: ApiCommonStackholdersUpdateStackholderPatch$Plain$Params, context?: HttpContext): Observable<UpdateStackholderCommandResult> {
    return this.apiCommonStackholdersUpdateStackholderPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateStackholderCommandResult>): UpdateStackholderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersUpdateStackholderPatch()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersUpdateStackholderPatch$Response(params?: ApiCommonStackholdersUpdateStackholderPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateStackholderCommandResult>> {
    return apiCommonStackholdersUpdateStackholderPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersUpdateStackholderPatch$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCommonStackholdersUpdateStackholderPatch(params?: ApiCommonStackholdersUpdateStackholderPatch$Params, context?: HttpContext): Observable<UpdateStackholderCommandResult> {
    return this.apiCommonStackholdersUpdateStackholderPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateStackholderCommandResult>): UpdateStackholderCommandResult => r.body)
    );
  }

  /** Path part for operation `apiCommonStackholdersDeleteStackholderDelete()` */
  static readonly ApiCommonStackholdersDeleteStackholderDeletePath = '/api/Common/Stackholders/DeleteStackholder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersDeleteStackholderDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersDeleteStackholderDelete$Plain$Response(params?: ApiCommonStackholdersDeleteStackholderDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteStackholderCommandResult>> {
    return apiCommonStackholdersDeleteStackholderDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersDeleteStackholderDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersDeleteStackholderDelete$Plain(params?: ApiCommonStackholdersDeleteStackholderDelete$Plain$Params, context?: HttpContext): Observable<DeleteStackholderCommandResult> {
    return this.apiCommonStackholdersDeleteStackholderDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteStackholderCommandResult>): DeleteStackholderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonStackholdersDeleteStackholderDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersDeleteStackholderDelete$Response(params?: ApiCommonStackholdersDeleteStackholderDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteStackholderCommandResult>> {
    return apiCommonStackholdersDeleteStackholderDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonStackholdersDeleteStackholderDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonStackholdersDeleteStackholderDelete(params?: ApiCommonStackholdersDeleteStackholderDelete$Params, context?: HttpContext): Observable<DeleteStackholderCommandResult> {
    return this.apiCommonStackholdersDeleteStackholderDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteStackholderCommandResult>): DeleteStackholderCommandResult => r.body)
    );
  }

}
